import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

const Wordmark = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2 group">
    <span className="font-heading font-bold text-2xl tracking-tight text-[#111111] leading-none">
      ZONA
    </span>
    <span className="font-heading font-medium text-2xl tracking-tight text-[#777777] leading-none group-hover:text-[#111111] transition-colors">
      SPORTS
    </span>
  </Link>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#E5E5E5] bg-white/80 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex h-20 items-center justify-between">
          <Wordmark />

          <nav className="hidden md:flex items-center gap-10">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-heading text-sm uppercase tracking-[0.18em] transition-colors ${
                    isActive ? "text-[#111111]" : "text-[#777777] hover:text-[#111111]"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block">
            <button
              data-testid="nav-cta-button"
              onClick={() => navigate("/contact")}
              className="group inline-flex items-center gap-2 bg-[#111111] px-6 py-3 text-sm font-heading uppercase tracking-[0.18em] text-white transition-colors hover:bg-[#333333]"
            >
              Get in touch
              <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-[#111111]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E5E5] bg-white" data-testid="nav-mobile-menu">
          <nav className="flex flex-col px-6 py-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 font-heading text-base uppercase tracking-[0.18em] ${
                    isActive ? "text-[#111111]" : "text-[#777777]"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => {
                setOpen(false);
                navigate("/contact");
              }}
              className="mt-3 bg-[#111111] px-6 py-4 text-sm font-heading uppercase tracking-[0.18em] text-white"
            >
              Get in touch
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
